import { entity } from 'simpler-state';

import entityReduxLogger from '../debug/helpers/entity-redux-logger';
import { NullableNumber, NullableString } from '../util/types';

export type ChartHoverData = {
  price: NullableNumber;
  time: NullableString;
  volume: NullableNumber;
  isHovering: boolean;
};

const INITIAL_STATE: ChartHoverData = {
  price: null,
  time: null,
  volume: null,
  isHovering: false,
};

const ChartHoverCache = entity<ChartHoverData>(
  INITIAL_STATE,
  entityReduxLogger('ChartHover', 'chart-hover'),
);

export const setChartHoverData = (data: Partial<ChartHoverData>) => {
  ChartHoverCache.set({ ...ChartHoverCache.get(), ...data });
};

export const clearChartHoverData = () => {
  ChartHoverCache.set(INITIAL_STATE);
};

export default {
  use: ChartHoverCache.use,
  get: ChartHoverCache.get,
  set: setChartHoverData,
  clear: clearChartHoverData,
};
